<script setup lang="ts">
import { setThemeTransitionOrigin } from '@/composables/useDarkMode'
import ToggleSwitch from 'primevue/toggleswitch'

const darkTheme = defineModel<boolean>()

function captureOrigin(e: MouseEvent) {
  setThemeTransitionOrigin(`${e.clientX}px`, `${e.clientY}px`)
}
</script>

<template>
  <div @click.capture="captureOrigin">
    <ToggleSwitch v-model="darkTheme" aria-label="Alternar tema">
      <template #handle="{ checked }">
        <i :class="['pi !text-xs', { 'pi-moon': checked, 'pi-sun': !checked }]" />
      </template>
    </ToggleSwitch>
  </div>
</template>
